import { ValidationResult } from "./interface.validation";

export class CnhValidator {
    static cnhFormat(item: any): ValidationResult {
        var CNH_REGEXP: any;
        if (item.value) {
            var tt: any = item.value.replace(/[^0-9]/gi, '');
           
            CNH_REGEXP = /([0-9]{11})/;

            if (item.value && !CNH_REGEXP.test(tt)) {
                return { "incorrectCnhFormat": true };
            }
        }   
       
        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/cnh.validation.ts
 **/